module.exports = __webpack_public_path__ + "static/media/item_2_3ll.e5927db6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/item_2_3ll.png
// module id = 120
// module chunks = 0